// Module
var code = "<div style=\"margin-right:-12px\"> <div style=\"padding:0 4px\"> <md-button class=\"md-raised\" ng-click=\"$ctrl.print()\" ng-disabled=\"$ctrl.disabled\">Drukuj listę uczniów</md-button> <md-tooltip md-direction=\"bottom\" ng-show=\"$ctrl.disabled\"> Lista zarejestrowanych uczniów jest pusta </md-tooltip> </div> </div> ";
// Exports
export default code;